import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};

  if (!values.appCode?.trim()) {
    errors.appCode = "App Code is required";
  }

  if (!values.appName?.trim()) {
    errors.appName = "App Name is required";
  }

  return errors;
};

const EditApplication = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  return (
    <Dialog
      title={ADD_NEW ? "Add Application" : `Edit ${props?.item?.appName}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <>
        <Form
          onSubmit={props.onSubmit}
          initialValues={{ active: true, ...props.item }}
          validator={validateForm}
          render={(formRenderProps) => (
            <>
              <FormElement
                style={{
                  maxWidth: 1200,
                }}
              >
                <fieldset className="p-3 ps-4">
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">
                      App Code&nbsp;
                    </Label>
                    <Field
                      name="appCode"
                      component={Input}
                      maxLength={2}
                      placeholder="Enter App Code"
                    />
                    {submitAttempted && formRenderProps.errors?.appCode && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.appCode}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      App Name&nbsp;
                    </Label>
                    <Field
                      name="appName"
                      component={Input}
                      placeholder="Enter App Name"
                    />
                    {submitAttempted && formRenderProps.errors?.appName && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.appName}</i>
                      </div>
                    )}
                  </div>
                  <Field name="active" component={Checkbox} label="Active" />
                </fieldset>
              </FormElement>

              <div className="dialog-footer">
                <Button
                  className="common-btn bgBtnSecondary me-3"
                  onClick={props.cancelEdit}
                >
                  Cancel
                </Button>
                <SubmitButton
                  className="me-3"
                  onClick={() => {
                    setSubmitAttempted(true);
                    formRenderProps.onSubmit();
                  }}
                  disabled={!formRenderProps.allowSubmit}
                  isLoading={props.isSubmitting}
                >
                  {ADD_NEW ? "Save" : "Update"}
                </SubmitButton>
              </div>
            </>
          )}
        />
      </>
    </Dialog>
  );
};

export default EditApplication;
